export default __webpack_public_path__ + "fonts/_/src/icons/PlanView.png";